import { render, staticRenderFns } from "./EuroprotelStok.vue?vue&type=template&id=65d5d603&scoped=true&"
import script from "./EuroprotelStok.vue?vue&type=script&lang=js&"
export * from "./EuroprotelStok.vue?vue&type=script&lang=js&"
import style0 from "./EuroprotelStok.vue?vue&type=style&index=0&id=65d5d603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5d603",
  null
  
)

export default component.exports